import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { API_BASE_URL } from '@/config/api';
import { productsApi } from '@/services/api.js';

const ApiStatus = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isLocalAPI = API_BASE_URL.includes('localhost');
  const currentEnvironment = isLocalAPI ? 'Development' : 'Production';

  const testApiCall = async () => {
    setIsLoading(true);
    try {
      console.log('%c[ApiStatus] Testing API call...', 'color: magenta; font-weight: bold;');
      const result = await productsApi.getProductById('288');
      console.log('%c[ApiStatus] API test SUCCESS:', 'color: green;', result);
      setTestResult({ success: true, data: result });
    } catch (error) {
      console.error('%c[ApiStatus] API test ERROR:', 'color: red;', error);
      setTestResult({ success: false, error: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Toggle Button - only visible in dev mode */}
      {process.env.NODE_ENV === 'development' && (
        <div className="fixed bottom-4 right-4 z-50">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsVisible(!isVisible)}
            className="shadow-lg"
          >
            API Info
          </Button>
        </div>
      )}

      {/* API Status Card */}
      {isVisible && (
        <Card className="fixed bottom-16 right-4 z-50 w-80 shadow-lg">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm flex items-center justify-between">
              API Configuration
              <Badge variant={isLocalAPI ? 'secondary' : 'default'}>
                {currentEnvironment}
              </Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div>
              <span className="font-medium">Current API:</span>
              <p className="text-xs text-muted-foreground break-all">
                {API_BASE_URL}
              </p>
            </div>
            <div className="text-xs text-muted-foreground">
              To switch environments, update <code>src/config/api.js</code>
            </div>
            
            {/* Test API Button */}
            <Button
              variant="outline" 
              size="sm"
              onClick={testApiCall}
              disabled={isLoading}
              className="w-full mt-2"
            >
              {isLoading ? 'Testing...' : 'Test API Call (Product 288)'}
            </Button>
            
            {/* Test Result Display */}
            {testResult && (
              <div className="mt-2 p-2 rounded text-xs">
                <div style={{ color: testResult.success ? 'green' : 'red' }}>
                  {testResult.success ? '✅ API Working' : '❌ API Error'}
                </div>
                {testResult.success ? (
                  <div className="text-muted-foreground">
                    Product: {testResult.data?.productName}
                  </div>
                ) : (
                  <div className="text-red-600">{testResult.error}</div>
                )}
              </div>
            )}
            
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsVisible(false)}
              className="w-full mt-2"
            >
              Close
            </Button>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ApiStatus;